// extracted by mini-css-extract-plugin
export default {"filterMenuPaper":"CasesFilterMenu_filterMenuPaper__rQa5U","filterMenuRow":"CasesFilterMenu_filterMenuRow__k81iN"};